import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import ActionButtons from "../../components/action_buttons";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { axiosApi } from "../../../services/axios_api";
import { Dropdown } from "primereact/dropdown";

const EditAddForm = ({
  onHide,
  editable,
  setRes,
  rowData,
  setShowDialog,
  getAlertData,
}) => {
  const [loading, setLoading] = useState(false);
  const [kiosks, setKiosks] = useState([]);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);

  useEffect(() => {

    const fetchKiosk = async () => {
      setLoading(true);
      try {
        const response = await axiosApi.get(
          `/Portal/kiosks/get-all`,
        );
        setKiosks(response.data.body);
      } catch (error) {
        toast.error("Failed to fetch Kiosk data.");
      } finally {
        setLoading(false);
      }
    };
    const fetchUser = async () => {
      setLoading(true);
      try {
        const response = await axiosApi.get(
          `/Portal/lists/users`,
        );
        setUsers(response.data.body);
      } catch (error) {
        toast.error("Failed to fetch roles data.");
      } finally {
        setLoading(false);
      }
    };
    const fetchRole = async () => {
      setLoading(true);
      try {
        const response = await axiosApi.get(
          `/Portal/lists/roles`,
        );
        setRoles(response.data.body);
      } catch (error) {
        toast.error("Failed to fetch roles data.");
      } finally {
        setLoading(false);
      }
    };
    fetchRole();
    fetchKiosk();
    fetchUser()
  }, []);

  const validationSchema = Yup.object({
    message: Yup.string().required("Message is required."),
    assignedUserId: Yup.string().required("Please select Assign User."),
    kioskId: Yup.string().required("Please select Kiosk."),
    roleId: Yup.string().required("Please select Role."),

  });

  // console.log(rowData);
  const formik = useFormik({
    initialValues: {
      kioskId: rowData?.kioskId || "",
      roleId: rowData?.roleId || "",
      assignedUserId: rowData?.assignedUserId || "",
      message: rowData?.message || "",
    },
    validationSchema,
    onSubmit: async (data) => {
      setLoading(true);
      try {
        let response;
        if (editable) {
          data.id = rowData.id;
          response = await axiosApi.put("/Portal/alerts/edit", data);
          toast.success(" Updated successfully!");
        } else {
          response = await axiosApi.post("/Portal/alerts/add", data);
          
          toast.success(" Added successfully!");
        }
        setRes(response.data);
        getAlertData();
        setShowDialog(false);
      } catch (error) {
        console.log(error.response);
        toast.error(
          error.response?.data?.message ||
          "An error occurred. Please try again."
        );
      } finally {
        setLoading(false);
      }
    },
  });



  return (
    <div className="main-form">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-fluid formgrid grid">

          <div className="field col-12 md:col-6">
            <label htmlFor="companyName">
              Kiosk <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="kioskId"
              name="kioskId"
              value={formik.values.kioskId}
              onChange={formik.handleChange}
              options={kiosks.map((koisks) => ({
                label: koisks.name,
                value: koisks.id,
              }))}
              placeholder="Select Role"
            />
            {formik.touched.kioskId && formik.errors.kioskId && (
              <small className="p-error">{formik.errors.kioskId}</small>
            )}
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="companyName">
              Assign User <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="assignedUserId"
              name="assignedUserId"
              value={formik.values.assignedUserId}
              onChange={formik.handleChange}
              options={users.map((users) => ({
                label: users.name,
                value: users.id,
              }))}
              placeholder="Select User"
            />
            {formik.touched.assignedUserId && formik.errors.assignedUserId && (
              <small className="p-error">{formik.errors.assignedUserId}</small>
            )}
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="companyName">
              Role <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="roleId"
              name="roleId"
              value={formik.values.roleId}
              onChange={formik.handleChange}
              options={roles.map((roles) => ({
                label: roles.name,
                value: roles.id,
              }))}
              placeholder="Select Role"
            />
            {formik.touched.roleId && formik.errors.roleId && (
              <small className="p-error">{formik.errors.roleId}</small>
            )}
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="feeName">
              Message <span className="text-danger"> *</span>
            </label>
            <InputText
              id="message"
              name="message"
              value={formik.values.message}
              placeholder="Enter Message"
              onChange={formik.handleChange}
            />
            {formik.touched.message && formik.errors.message && (
              <small className="p-error">{formik.errors.message}</small>
            )}
          </div>
        </div>

        <div className="form-buttons mt-4">
          <ActionButtons
            loading={loading}
            onCancel={onHide}
            onSave={formik.handleSubmit}
            saveLabel={editable ? "Update Changes" : "Save Changes"}
            showSave={true}
            cancelLabel="Cancel"
          />
        </div>
      </form>
    </div>
  );
};

export default EditAddForm;
